import('./bootstrap').catch((error) =>
  console.log('analytics-web-ui is down', error),
);
export {};
